import type { TextStylesExtra } from '../../types'
import { setMediaQuery } from '../../utilities'
import { fontSize } from './font-size'
import { lineHeight } from './line-height'

export const textStylesExtra: TextStylesExtra = {
  'sb-text-body': `
    font-size: ${fontSize[18]};
    line-height: ${lineHeight[25]};

    ${setMediaQuery(
      'medium',
      `
      font-size: ${fontSize[18]};
      line-height: ${lineHeight[28]};
    `
    )}
  `,
  'sb-text-blockquote': `
    font-size:  ${fontSize[24]};
    line-height: ${lineHeight[30]};

    ${setMediaQuery(
      'medium',
      `
      font-size: ${fontSize[34]};
      line-height: ${lineHeight[50]};
    `
    )}
  `,
  'sb-text-quote': `
    font-size: ${fontSize[19]};
    line-height: ${lineHeight[28]};

    ${setMediaQuery(
      'medium',
      `
      font-size: ${fontSize[24]};
      line-height: ${lineHeight[35]};
    `
    )}
  `,
  'sb-text-label': `
    font-size: ${fontSize[18]};
    line-height: ${lineHeight[25]};
  `,
  'sb-text-overline': `
    font-size: ${fontSize[16]};
    line-height: ${lineHeight[25]};
    text-transform: uppercase;
    letter-spacing: 1px;
  `,
  'sb-text-standfirst': `
    font-size: ${fontSize[19]};
    line-height: ${lineHeight[28]};

    ${setMediaQuery(
      'medium',
      `
      font-size: ${fontSize[24]};
      line-height: ${lineHeight[35]};
    `
    )}
  `,
  'sb-text-large-print': `
    font-size: ${fontSize[30]};
    line-height: ${lineHeight[35]};

    ${setMediaQuery(
      'medium',
      `
      font-size: ${fontSize[40]};
      line-height: ${lineHeight[50]};
    `
    )}
  `,
  'sb-text-small-print-compact': `
    font-size: ${fontSize[16]};
    line-height: ${lineHeight[20]};
  `,
  'sb-text-small-print-regular': `
    font-size: ${fontSize[16]};
    line-height: ${lineHeight[25]};
  `,
  'sb-text-very-small-print': `
    font-size: ${fontSize[14]};
    line-height: ${lineHeight[15]};

    ${setMediaQuery(
      'medium',
      `
      font-size: ${fontSize[14]};
      line-height: ${lineHeight[20]};
    `
    )}
  `,
  'sb-text-title-300': `
    font-size: ${fontSize[18]};
    line-height: ${lineHeight[25]};
  `,
  'sb-text-title-400': `
    font-size: ${fontSize[19]};
    line-height: ${lineHeight[25]};

    ${setMediaQuery(
      'medium',
      `
      font-size: ${fontSize[24]};
      line-height: ${lineHeight[30]};
    `
    )}
  `,
  'sb-text-title-500': `
    font-size: ${fontSize[22]};
    line-height: ${lineHeight[25]};

    ${setMediaQuery(
      'medium',
      `
      font-size: ${fontSize[28]};
      line-height: ${lineHeight[35]};
    `
    )}
  `,
  'sb-text-title-600': `
    font-size: ${fontSize[25]};
    line-height: ${lineHeight[30]};

    ${setMediaQuery(
      'medium',
      `
      font-size: ${fontSize[33]};
      line-height: ${lineHeight[40]};
    `
    )}
  `,
  'sb-text-title-650': `
    font-size: ${fontSize[25]};
    line-height: ${lineHeight[30]};

    ${setMediaQuery(
      'medium',
      `
      font-size: ${fontSize[40]};
      line-height: ${lineHeight[50]};
    `
    )}
  `,
  'sb-text-title-700': `
    font-size: ${fontSize[30]};
    line-height: ${lineHeight[35]};

    ${setMediaQuery(
      'medium',
      `
      font-size: ${fontSize[48]};
      line-height: ${lineHeight[60]};
    `
    )}
  `,
}
